import { Alert, Button } from 'components';
import { cn } from 'domain/core';
import { useLoginAs } from 'domain/hooks/useLogin';
import { User } from 'domain/models';
import { useAlertState } from 'layout';
import { useTranslation } from 'react-i18next';

export const UserOptions = ({ values }: { values: User }) => {
	const { t } = useTranslation(['labels']);

	const { pushAlert } = useAlertState();
	const requestTokenAs = useLoginAs();
	const loginAs = async () => {
		if (!values?.id) {
			return;
		}
		try {
			await requestTokenAs(values.id as any);
			// Reload and go to the home page
			window.location.href = '/';
		} catch (err) {
			pushAlert({
				alert: Alert.error({
					title: t('labels:notification.error_title'),
					message: t('labels:notification.error_title'),
					symbol: Symbol('loginError'),
				}),
				duration: 3000,
			});
		}
	};

	return (
		<div
			className={cn('flex', 'w-full', 'justify-end', 'items-end', 'flex-col')}>
			<div>
				<Button
					onClick={() => {
						loginAs();
					}}>
					{t('labels:loginAs')}
				</Button>
			</div>
		</div>
	);
};
